// src/app/home/home.component.ts

import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  // Remove or comment out the standalone property
  // standalone: true
})
export class HomeComponent { }
